declare global {
  interface Window {
    studioUrlWhitelist?: string[]
  }
}

export default defineNuxtPlugin({
  name: 'content-preview',
  setup: async () => {
    const { configApiDomains: { cmsBaseUrl }, enableFContentProxy, configStudioUrlWhitelist } = useFeatureFlags()
    const { cmsApiRoutePrefix, isDev } = useRuntimeConfig().public
    const { isPreview, isDisablePreview, previewDateTime } = useCms()
    const previewDateTimeCookie = useCookie('previewDateTime')

    if (isPreview && previewDateTime)
      previewDateTimeCookie.value = previewDateTime
    else if (isDisablePreview)
      previewDateTimeCookie.value = null

    if (!isPreview) return

    const { sliderMetadata } = await import('#content/config/preview')
    const url = isDev || enableFContentProxy ? cmsApiRoutePrefix : cmsBaseUrl

    useHead({
      bodyAttrs: {
        'data-cm-metadata': JSON.stringify(sliderMetadata)
      },
      script: [
        {
          key: 'cms-preview-studio-url-whitelist',
          innerHTML: `window.studioUrlWhitelist = ${JSON.stringify(configStudioUrlWhitelist || []).replace(/</g, '\\u003c')}`,
          tagPosition: 'head',
          tagPriority: 1
        },
        {
          key: 'cms-preview',
          src: `${url}/preview/static/coremedia.preview.js`,
          tagPriority: 2
        }
      ]
    })
  }
})
